module.exports = __webpack_public_path__ + "static/media/femaleFeminine.b1e275aa.png";